import Markdown, {
  RenderRules,
} from "@ronradtke/react-native-markdown-display";
import React, { memo } from "react";
import { StyleSheet, ViewStyle } from "react-native";

import { Box } from "@/components/atoms";

/**
 * Props for MarkdownRendererView
 */
interface MarkdownRendererViewProps {
  content: string;
  testID?: string;
  convertedStyles: StyleSheet.NamedStyles<unknown>;
  containerStyle: ViewStyle;
  onLinkPress: (url: string) => boolean;
  rules: RenderRules;
}

/**
 * View component for rendering markdown content with custom styles and link handling
 * @param root0 - Component props
 * @param root0.content - Markdown text content to render
 * @param root0.testID - Optional test ID for testing purposes
 * @param root0.convertedStyles - Theme-converted markdown styles for consistent theming
 * @param root0.containerStyle - Container view style for positioning and layout
 * @param root0.onLinkPress - Callback invoked when user clicks a link, returns whether link was handled
 * @param root0.rules - Custom markdown render rules (e.g., link rule wiring player testIDs)
 */
const MarkdownRendererView = ({
  content,
  testID,
  convertedStyles,
  containerStyle,
  onLinkPress,
  rules,
}: MarkdownRendererViewProps) => (
  <Box
    testID={testID}
    // eslint-disable-next-line no-restricted-syntax -- data-driven containerStyle (theme-driven backgroundColor) passed as an opaque ViewStyle prop; no closed token for the arbitrary theme color
    UNSAFE_style={containerStyle as Record<string, string | number>}
  >
    <Markdown
      // eslint-disable-next-line no-restricted-syntax -- markdown-display node-name->style map API, not an RN inline style attribute
      style={convertedStyles}
      onLinkPress={onLinkPress}
      rules={rules}
    >
      {content}
    </Markdown>
  </Box>
);

MarkdownRendererView.displayName = "MarkdownRendererView";
export default memo(MarkdownRendererView);
